<template>
  <div>
    <b-row class="p-5 mb-0 ranking-search" align-h="center">
      <b-col lg="4" md="4" sm="12" class="text-center mb-2">
        <h2>Buscar Ranking</h2>
      </b-col>
      <b-col lg="4" md="4" sm="12" class="text-center mb-2">
        <b-form-select
          v-model="modalidad"
          :options="options"
          size="lg"
          class="rank-select"
        ></b-form-select>
      </b-col>
      <b-col lg="4" md="4" sm="12" class="text-center mb-2">
        <b-button
          :to="`/ranking/${modalidad}`"
          variant="secondary"
          shadow-sm
          style="color:#fff; border-radius:50px; text-transform:uppercase; font-size:14px"
          class="shadow"
        >Buscar</b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      required: true
    }
  },
  methods: {
    // a computed getter
    isOdd: function(index) {
      return index < 4 || index > 7; //index % 2 == 0 ;
    }
  },
  data() {
    return {
      modalidad: null,
      optionsx: [
        {
          value: "1",
          text: "3M"
        },
        {
          id: "2",
          text: "3F"
        },
        {
          value: "3",
          text: "4M"
        },
        {
          value: "4",
          text: "4F"
        }
      ],
      categorias: null,
      categoriasOptions: [
        { value: null, text: "Categoría" },
        { value: "01", text: "Categoría 1" },
        { value: "02", text: "Categoría 2" },
        { value: "03", text: "Categoría 3" },
        { value: "04", text: "Categoría 4" }
      ],
      mockRank: [
        {
          id: 1,
          title: "G25",
          player: [
            {
              first_name: "Neysa",
              last_name: "MacDonogh",
              rank: 18,
              img: "http://dummyimage.com/150x150.jpg/cc0000/ffffff"
            },
            {
              first_name: "Horst",
              last_name: "Plumridge",
              rank: 14,
              img: "http://dummyimage.com/150x150.jpg/ff4444/ffffff"
            }
          ]
        },
        {
          id: 2,
          title: "Mazda2",
          player: [
            {
              first_name: "Lizette",
              last_name: "Tinsey",
              rank: 13,
              img: "http://dummyimage.com/150x150.jpg/cc0000/ffffff"
            },
            {
              first_name: "Reilly",
              last_name: "Solland",
              rank: 9,
              img: "http://dummyimage.com/150x150.jpg/cc0000/ffffff"
            }
          ]
        },
        {
          id: 3,
          title: "Safari",
          player: [
            {
              first_name: "Connie",
              last_name: "Maskew",
              rank: 8,
              img: "http://dummyimage.com/150x150.jpg/cc0000/ffffff"
            },
            {
              first_name: "Deborah",
              last_name: "Clara",
              rank: 4,
              img: "http://dummyimage.com/150x150.jpg/ff4444/ffffff"
            }
          ]
        },
        {
          id: 4,
          title: "Pajero",
          player: [
            {
              first_name: "Odetta",
              last_name: "Spain-Gower",
              rank: 6,
              img: "http://dummyimage.com/150x150.jpg/ff4444/ffffff"
            },
            {
              first_name: "Ulrich",
              last_name: "Lorente",
              rank: 5,
              img: "http://dummyimage.com/150x150.jpg/ff4444/ffffff"
            }
          ]
        },
        {
          id: 5,
          title: "Sequoia",
          player: [
            {
              first_name: "Dana",
              last_name: "Naire",
              rank: 6,
              img: "http://dummyimage.com/150x150.jpg/cc0000/ffffff"
            },
            {
              first_name: "Merlina",
              last_name: "Worswick",
              rank: 7,
              img: "http://dummyimage.com/150x150.jpg/ff4444/ffffff"
            }
          ]
        },
        {
          id: 6,
          title: "Vantage",
          player: [
            {
              first_name: "Charlena",
              last_name: "Coultard",
              rank: 17,
              img: "http://dummyimage.com/150x150.jpg/cc0000/ffffff"
            },
            {
              first_name: "Reese",
              last_name: "Tapton",
              rank: 1,
              img: "http://dummyimage.com/150x150.jpg/ff4444/ffffff"
            }
          ]
        },
        {
          id: 7,
          title: "LX",
          player: [
            {
              first_name: "Alastair",
              last_name: "Dorro",
              rank: 10,
              img: "http://dummyimage.com/150x150.jpg/cc0000/ffffff"
            },
            {
              first_name: "Holden",
              last_name: "Canadas",
              rank: 20,
              img: "http://dummyimage.com/150x150.jpg/5fa2dd/ffffff"
            }
          ]
        },
        {
          id: 8,
          title: "Firefly",
          player: [
            {
              first_name: "Sanders",
              last_name: "Feria",
              rank: 5,
              img: "http://dummyimage.com/150x150.jpg/ff4444/ffffff"
            },
            {
              first_name: "Tine",
              last_name: "Douthwaite",
              rank: 5,
              img: "http://dummyimage.com/150x150.jpg/ff4444/ffffff"
            }
          ]
        },
        {
          id: 9,
          title: "iQ",
          player: [
            {
              first_name: "Corabelle",
              last_name: "Pymm",
              rank: 15,
              img: "http://dummyimage.com/150x150.jpg/5fa2dd/ffffff"
            },
            {
              first_name: "Randy",
              last_name: "Jarry",
              rank: 2,
              img: "http://dummyimage.com/150x150.jpg/cc0000/ffffff"
            }
          ]
        },
        {
          id: 10,
          title: "W201",
          player: [
            {
              first_name: "Frederik",
              last_name: "Simeoni",
              rank: 15,
              img: "http://dummyimage.com/150x150.jpg/5fa2dd/ffffff"
            },
            {
              first_name: "Arlin",
              last_name: "Hadkins",
              rank: 5,
              img: "http://dummyimage.com/150x150.jpg/5fa2dd/ffffff"
            }
          ]
        }
      ]
    };
  }
};
</script>
<style scoped>
h2 {
  color: white;
}
.rank-select {
  color: #fff;
  width: 200px;
  margin: auto;
  border: 0px solid;
  border-bottom: 1px solid white;
  border-radius: 0;
  background: #817f7f
    url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='white' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e")
    no-repeat right 0.75rem center/8px 10px !important;
}

.ranking-search {
  background: #817f7f;
  color: #fff;
  align-items: center;
}
.inner-ranking {
  display: flex;

  margin: auto;
  align-items: center;
}
</style>




